// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { CONTACT_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/contactType';
import { COMMUNICATION_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/communicationType';

export const CONTACT_TYPE_FIELD: FormFieldSchema<string> = {
  label: 'Contact type',
  name: 'tph_contact_type',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: CONTACT_TYPE_OPTIONS,
  },
  required: true,
  validate: required('Contact type is required.'),
};

export const COMMUNICATION_FIELD: FormFieldSchema<string> = {
  label: 'Communication type',
  name: 'tph_communication_type',
  type: U21FormFieldTypes.SELECT,
  fieldProps: {
    options: COMMUNICATION_TYPE_OPTIONS,
  },
  default: 'L',
  required: true,
  validate: required('Communication type is required.'),
};

// TODO add a catalogue, FIAU does not have one
export const COUNTRY_PREFIX_FIELD: FormFieldSchema<string> = {
  label: 'Country prefix',
  name: 'tph_country_prefix',
  type: U21FormFieldTypes.TEXT,
  default: '+1', // US
  required: true,
  validate: required('Country prefix is required.'),
};

export const NUMBER_FIELD: FormFieldSchema<string> = {
  label: 'Number',
  name: 'tph_number',
  type: U21FormFieldTypes.TEXT,
  required: true,
  validate: required('Phone number is required.'),
};

export const EXTENSION_FIELD: FormFieldSchema<string> = {
  label: 'Extension',
  name: 'tph_extension',
  type: U21FormFieldTypes.TEXT,
};

export const COMMENTS_FIELD: FormFieldSchema<string> = {
  label: 'Comments',
  name: 'comments',
  type: U21FormFieldTypes.TEXTAREA,
};

export const T_PHONE_SCHEMA = [
  CONTACT_TYPE_FIELD,
  COMMUNICATION_FIELD,
  COUNTRY_PREFIX_FIELD,
  NUMBER_FIELD,
  EXTENSION_FIELD,
  COMMENTS_FIELD,
];
